'use client';

import { FC } from 'react';
import { CopyIcon, HeartIcon, PrintIcon, ShareModal } from '@/components';
import { ActionsBox, Container, StyledButton } from './styled';
import { IHousingObjectResponse } from '@/types';
import { useWatchlistCard, usePrintHousing } from '@/hooks';
import { ProdGate } from '@/components';

type HeadShellProps = {
  data: IHousingObjectResponse;
  isProject?: boolean;
  price: React.ReactNode;
  children: React.ReactNode;
};

export const HeadShell: FC<HeadShellProps> = ({ data, isProject = false, price, children }) => {
  const { inWatchlist, toggleWatch } = useWatchlistCard(data, isProject);
  const { handlePrint } = usePrintHousing();

  const slugLink = `${data.slug}__${data.id}`;

  return (
    <Container>
      {children}
      <ActionsBox>
        {price}
        <ProdGate>
          <StyledButton variant="transparent" onClick={handlePrint} aria-label="Print">
            <PrintIcon aria-hidden="true" />
          </StyledButton>
        </ProdGate>
        <ShareModal
          id={data.id}
          title={data.title}
          description={data.description}
          media={data.imageFullUrl}
          slugLink={slugLink}
          trigger={
            <StyledButton variant="transparent" aria-label="Share">
              <CopyIcon aria-hidden="true" />
            </StyledButton>
          }
        />
        <StyledButton
          variant="transparent"
          onClick={toggleWatch}
          aria-label={inWatchlist ? 'Remove from watchlist' : 'Add to watchlist'}
        >
          <HeartIcon isActive={inWatchlist} aria-hidden="true" />
        </StyledButton>
      </ActionsBox>
    </Container>
  );
};
